'use strict';

var RomSummaryOpportunityTrendsViewport = function RomSummaryOpportunityTrendsViewport(ChartViewport, chartGroups, chartTiles, chartCurve, chartSimpleBars) {
  var chartParams = require('./RomSummaryOpportunityTrendsViewportParams');
  var chartScales = require('./RomSummaryOpportunityTrendsScales');
  var Chart = function Chart(container) {
    var groups = chartGroups('dimension');
    var tiles = chartTiles('any', 'value', 'tiles').withHeight(2);
    var curve = chartCurve('dimension', 'revOpp').discontinuous(true);
    var recaptureBar = chartSimpleBars('recapture');
    var spillBar = chartSimpleBars('spill');
    ChartViewport.call(this, container, chartParams, chartScales, groups, recaptureBar, spillBar, tiles);
    this._render = this.render;
    this.render = function () {
      this._render.apply(this, arguments);
      this.callForDataGroup([curve], {
        xScale: this.scales.xScale,
        yScale: this.scales.yScaleRight
      });
    };
    this._resetBrush = this.resetBrush;
    this.resetBrush = function () {
      this._resetBrush.apply(this, arguments);
    };
  };
  Chart.prototype = Object.create(ChartViewport.prototype);
  Chart.constructor = Chart;
  return Chart;
};
RomSummaryOpportunityTrendsViewport.$inject = ['ChartViewport', 'ChartElementsGroup', 'ChartElementsTiles', 'ChartElementsCurves', 'ChartElementsSimpleBars', 'd3Helper'];
module.exports = RomSummaryOpportunityTrendsViewport;